import { Routes, Route, useLocation } from 'react-router-dom';
import { PermitGuardRoute } from './PermitGuardRoute';
import { RouteConfig } from './RouteConfig';

export const AppRouter = () => {
  const location = useLocation();
  return (
    <Routes>
      {RouteConfig.map((route) => {
        // A historical entry must not reuse another route's previously allowed policy.
        const element = route.isJudge ? <PermitGuardRoute key={location.key} themeType={route.themeType}>{route.element}</PermitGuardRoute> : route.element;

        return <Route key={route.path} path={route.path} element={element} />;
      })}
    </Routes>
  );
};
